import { render } from "./OrganizationLogo.vue?vue&type=template&id=5c5eda4d"
import script from "./OrganizationLogo.vue?vue&type=script&lang=js"
export * from "./OrganizationLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__